import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import brand from 'assets/styles/variables/brand';
import Icon from 'components/icons/icon.component';
import { formatWithPriceBands } from 'helpers/price-band.helper';
import { IProduct } from 'modules/menu/menu.types';

const StyledListItem = styled.li`
	margin: 5px 0 0 0;
	padding: 0 15px 0 0;
	display: flex;
	align-items: center;
	border-radius: 10px;
	background: ${brand.neutral};
	overflow: hidden;

	img {
		width: 56px;
		margin-right: 25px;
	}
`;

const StyledColumn = styled.div`
	min-width: 120px;
	min-height: 56px;
	margin: 0 45px 0 0;
	padding: 15px 0 15px 5px;
	padding-left: 5px;
	display: flex;
	align-items: center;
	overflow-wrap: anywhere;

	&:first-child {
		min-width: 50px;
		width: 50px;
		padding: 0;
		margin: 0;

		img {
			margin: 0;
		}
	}

	&:nth-child(2) {
		margin-left: 20px;
	}

	&:nth-child(2),
	&:nth-child(3),
	&:nth-child(4) {
		min-width: 250px;
		max-width: 250px;
	}

	&:last-child {
		width: 30px;
		min-width: 30px;
		margin: 0 0 0 auto;
		display: flex;
		justify-content: center;
	}
`;

// Props for component
interface IComponentProps {
	item: IProduct;
	activeAccountId: string;
}
// product list item component
const ProductListItem: FunctionComponent<IComponentProps> = ({
	item,
	activeAccountId,
}) => {
	return (
		<StyledListItem key={item.id} aria-label="product-item">
			<StyledColumn>
				{!!item.imageUrl && (
					<img
						src={item.imageUrl!}
						alt={`${item.name} product`}
						width="50"
					/>
				)}
			</StyledColumn>
			<StyledColumn>{item.name}</StyledColumn>
			<StyledColumn>{item.sku}</StyledColumn>
			<StyledColumn>{formatWithPriceBands(item)}</StyledColumn>
			<StyledColumn>
				<Link
					to={`/menus/product/edit/${item.id}/details?activeAccount=${activeAccountId}`}
				>
					<Icon name="edit" colour="primary" />
				</Link>
			</StyledColumn>
		</StyledListItem>
	);
};

export default ProductListItem;
